<template>
    <section id="detailWinnerList">
        <div class="detail presentBg2">
            <div class="wrap">
                <!-- 本期得獎名單 -->
                <div id="winner_now" class="tab_content">
                    <div class="winnder_page"><b>得獎名單</b></div>
                    <div v-for="(lottery, index) in formattedWinnerList" :key="index">
                        <h3 class=" title-month mt-40 mb-30" v-if="lottery.isNewMonth"><span>{{ lottery.month }}月得主 ({{ lottery.year }})</span></h3>
                        <table class="list-table" border="0" cellspacing="1" cellpadding="0">
                            <thead>

                            <tr class="all">
                                <th colspan="6"><h3>{{ lottery.lotteryName }}</h3></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(winner, idx) in lottery.winnerList" :key="idx">
                                <td >{{ winner.name }}</td>
                                <td >{{ winner.phone }}</td>
                                <td >{{ winner.pid }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div> <!-- winner_now end -->
            </div><!-- /wrap -->
        </div>
    </section>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import axios from 'axios';
import {getApi} from "@/utils/callApi";
import apiConfig from "@/utils/apiConfig";

const winnerList = ref([]);

const fetchWinnerList=()=>{
    getApi(apiConfig.lotteryList+'?type=LP')
        .then((response)=>{
            if(response.data.code===200){
                winnerList.value=response.data.data.sort((a,b)=>b.id - a.id);
            }
        })
        .catch((error) => {
            console.error('Error fetching winner list:', error);
        });
}

const formattedWinnerList = computed(() => {
    let previousMonth = null;
    let previousYear = null;
    return winnerList.value.map((value) => {
        const isNewMonth = previousMonth !== value.month || previousYear !== value.year;
        previousMonth = value.month;
        previousYear = value.year;
        return {
            month: isNewMonth ? value.month : null,
            year: isNewMonth ? value.year : null,
            lotteryName: value.lotteryName,
            winnerList: value.lotteryWinnerList,
            isNewMonth,
        };
    });
});

onMounted(() => {
    fetchWinnerList();
});
</script>
<style lang="scss">
#detailWinnerList{
    padding-top: 175px;
}
table{
    background-color: #fff;
}
.presentBg2{
    background-color: #FFF5D9;
    background: url("../assets/bg-plus.svg") top center  repeat;
}
.winnder_page{
    color: #005BAC;
    font-size: 30px;
}
.tab_content{
    text-align: center
}

@media (max-width: $pc) {
    .detail .wrap {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
    }

    table.list-table {
        width: 100%;
    }
}
.title-month{
    background:$yellow-800;
    border:3px solid #4f4f4f;
    position:relative;
    border-radius: 50px;
    padding:5px 10px;
    text-align: center;
    color:#4f4f4f;
    max-width:300px;
    font-size:30px;
    margin: 0 auto ;
    &:before{
        content:"";
        width:20px;
        height:20px;
        display:inline-block;
        background-image: url(../assets/title-flower.png);
        background-size:contain;
        background-repeat: no-repeat;
        position:absolute;
        left:8px;
        top:15px;
    }
    &:after{
        content:"";
        width:20px;
        height:20px;
        display:inline-block;
        background-image: url(../assets/title-flower.png);
        background-size:contain;
        background-repeat: no-repeat;
        position:absolute;
        right:8px;
        top:15px;
    }
    @media screen and (max-width: $mobile-small) {
        width:80%;
        font-size: 24px;
    }
}

.list-table {
    margin: 20px auto;
    -moz-border-radius: 10px 10px 0 0;
    -webkit-border-radius: 10px;
    border-radius: 30px 30px 0 0;
    width: 1100px;
    text-align: center;
    vertical-align: middle;
}
.list-table tr.all {
    float: none;
    width: 100%;
    background-color: $blue-700;
}
.list-table tr {
    float: left;
    width: 50%;
}

.list-table th {
    color: #fff;
    font-weight: bold;
    padding: 10px;
    text-align: center;
    font-size: 20px;
    border-radius: 30px 30px 0 0;
}

.list-table td {
    box-sizing: border-box;
    padding: 5px 1px;
    border-bottom: 1px dashed #fff;
    background-color: #F2F7FC;
    vertical-align: middle;
    line-height: 30px;
    table-layout: auto;
    width: 10%;
}

.list-table+.title-month {
    margin-top: 60px;
}
@media (max-width: 800px) {
    .list-table {
        width: 100%;
        font-size: 16px;
        line-height: 20px;
    }
    .list-table tr {
        width: 100%;
        float: none;
    }
}
@media (max-width:650px) {
    .list-table {
        width: 100%;
        font-size: 16px;
        line-height: 20px;
    }
    .title-month {
        line-height: 45px;
        font-size: 24px;
        margin: 20px auto 10px;
    }
    .list-table th {
        font-size: 18px;
    }

}
</style>




